import axios from ".";

export const getAllDisposition = (initiativeId?: any) => {
  return axios({
    method: "GET",
    url: `/dispositions/latest/${initiativeId}`,
  });
};

export const addDisposition = (data: any) => {
  return axios({
    method: "POST",
    url: `/dispositions/create`,
    data: data,
  });
};

export const updateDisposition = (id: number, data?: any) => {
  return axios({
    method: "PUT",
    url: `/dispositions/update/${id}`,
    data: data,
  });
};

export const deleteDispositionByID = (id: number | null) => {
  return axios({
    method: "DELETE",
    url: `/dispositions/delete/${id}`,
  });
};
